import { api } from './api';

export type OperadorLog = 'igual' | 'distinto' | 'empieza' | 'contiene' | 'existe' | 'noExiste';

export interface FiltroLog {
  campo: string;
  op: OperadorLog;
  valor?: string;
}

export interface ConsultaLogs {
  filtros?: FiltroLog[];
  desde?: number;
  hasta?: number;
}

export interface ResumenLogsDto {
  total: number;
  tamanoBytes: number | null;
  coleccion: string;
  campos: { campo: string; enMuestra: number }[];
  tamanoMuestra: number;
}

export interface ValoresCampoDto {
  total: number;
  page: number;
  pageSize: number;
  items: { valor: string; cantidad: number }[];
}

export interface LogMongoDto {
  _mongoId: string;
  time?: number;
  level?: number;
  service?: string;
  hostname?: string;
  msg?: string;
  [campo: string]: unknown;
}

export interface BusquedaLogsDto {
  total: number;
  page: number;
  pageSize: number;
  items: LogMongoDto[];
}

/** Consulta y limpieza manual de los logs guardados en MongoDB (solo SYSADMIN). */
export const logsMongoService = {
  resumen(): Promise<ResumenLogsDto> {
    return api.get('/sysadmin/logs-mongo/resumen');
  },

  valores(
    consulta: ConsultaLogs & {
      campo: string;
      prefijo?: string;
      page?: number;
      pageSize?: number;
      orden?: 'cantidad' | 'valor';
      dir?: 'asc' | 'desc';
    }
  ): Promise<ValoresCampoDto> {
    return api.post('/sysadmin/logs-mongo/valores', consulta);
  },

  buscar(consulta: ConsultaLogs & { page?: number; pageSize?: number; dir?: 'asc' | 'desc' }): Promise<BusquedaLogsDto> {
    return api.post('/sysadmin/logs-mongo/buscar', consulta);
  },

  eliminar(consulta: ConsultaLogs & { totalEsperado: number }): Promise<{ eliminados: number }> {
    return api.post('/sysadmin/logs-mongo/eliminar', consulta);
  },
};
